/**
 * This function filters out a specific beneficiary from both primary and contingent beneficiary lists.
 * It takes an object containing primary and contingent beneficiary shares and a beneficiary ID to exclude.
 * 
 * @param {Object} beneficiaryShares - The object containing arrays of primary and contingent beneficiaries.
 * @param {Array} beneficiaryShares.primaryBeneficiaries - Array of primary beneficiary objects.
 * @param {Array} beneficiaryShares.contingentBeneficiaries - Array of contingent beneficiary objects.
 * @param {string} beneficiaryID - The ID of the beneficiary to exclude from the returned lists.
 * 
 * @returns {Object} - An object with two properties, 'primary' and 'contingent', each containing arrays of beneficiaries 
 *                     excluding the one with the specified ID.
 */
export default (beneficiaryShares, beneficiaryID) => {
  const beneficiaries = {
    primary: [],
    contingent: []
  };
  beneficiaryShares.primaryBeneficiaries.map(primaryBeneficiary => {
    if (primaryBeneficiary.beneficiaryID !== beneficiaryID) {
      beneficiaries.primary.push({
        beneficiaryID: primaryBeneficiary.beneficiaryID,
        firstname: primaryBeneficiary.firstname,
        lastname: primaryBeneficiary.lastname,
        relationship: primaryBeneficiary.relationship,
        type: primaryBeneficiary.type,
        birthdate: primaryBeneficiary.birthdate,
        shares: Number(primaryBeneficiary.shares)
      });
    }
    return null;
  });
  beneficiaryShares.contingentBeneficiaries.map(contingentBeneficiary => {
    if (contingentBeneficiary.beneficiaryID !== beneficiaryID) {
      beneficiaries.contingent.push({
        beneficiaryID: contingentBeneficiary.beneficiaryID,
        firstname: contingentBeneficiary.firstname,
        lastname: contingentBeneficiary.lastname,
        relationship: contingentBeneficiary.relationship,
        type: contingentBeneficiary.type,
        birthdate: contingentBeneficiary.birthdate,
        shares: Number(contingentBeneficiary.shares)
      });
    }
    return null;
  });
  return beneficiaries;
};